'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.includes || implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/array-includes/polyfill.js
// module id = 131
// module chunks = 0